export default "/imgs/jrn-3.png"